import { dbCep } from "~db/db";

export const buscarRuasPorCidadeId = async (cidadeId) => {
  if (!cidadeId) return [];

  try {
    const ruas = await dbCep.cep
      .where("cidadeId")
      .equals(cidadeId)
      .toArray();

    return ruas;
  } catch (err) {
    console.error("Erro ao buscar ruas no IndexedDB:", err);
    return [];
  }
};

export const validarCepExOperacional = async (value) => {
  const cepNormalizado = String(value ?? "").replace(/\D/g, "");
  if (cepNormalizado.length !== 8) return undefined;

  try {
    const registroCep = await dbCep.cep.where("cep").equals(cepNormalizado).first();
    if (!registroCep || String(registroCep.logradouro ?? "").trim()) return undefined;

    const cepsDaCidade = await dbCep.cep.where("cidadeId").equals(registroCep.cidadeId).toArray();
    const possuiCepPorRua = cepsDaCidade.some(
      (item) =>
        Boolean(String(item.logradouro ?? "").trim()) &&
        String(item.cep ?? "").replace(/\D/g, "") !== cepNormalizado
    );

    return possuiCepPorRua ? "Selecione uma rua específica antes de salvar" : undefined;
  } catch (error) {
    console.error("Erro ao validar CEP ex-operacional:", error);
    return "Não foi possível validar o CEP. Tente novamente.";
  }
};
